import { Component, OnInit } from '@angular/core';
import { getAuth, signOut } from 'firebase/auth';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    // const auth = getAuth();
    // signOut(auth).then(() => {
    //   // Sign-out successful.
    //   console.log('logout')
    // }).catch((error) => {
    //   // An error happened.
    // });
  }

}
